import { getLogger } from '@confluence/logger';

const logger = getLogger('highlight-action');

export interface CreateTrelloCardParams {
	text: string;
	contentId: string;
}

export interface CreateTrelloCardResponse {
	cardId: string;
	cardUrl: string;
	success: boolean;
}

/**
 * Creates a Trello card with the provided text content
 * @param params - The parameters for creating a Trello card
 * @returns Promise<CreateTrelloCardResponse>
 */
export const createTrelloCardHandle = async ({
	text,
	contentId,
}: CreateTrelloCardParams): Promise<CreateTrelloCardResponse | null> => {
	logger.info`Creating Trello card for contentId=${contentId} textLength=${text.length}`;

	// TODO: Implement Trello card creation
	return null;
};
